import nodeStyle from './node.module.scss';

/* Icons */
// Access Point
import apOnlineIcon from "assets/images/icons/img_device_ap_on.svg";
import apOfflineIcon from "assets/images/icons/img_device_ap_off.svg";
import apWarningIcon from "assets/images/icons/img_device_ap_warning.svg";
import apDormantIcon from "assets/images/icons/img_device_ap_dormant.svg";
import apDisabledIcon from "assets/images/icons/img_device_ap_disable.svg";
// Switch
import switchOnlineIcon from "assets/images/icons/img_device_switch_on.svg";
import switchOfflineIcon from "assets/images/icons/img_device_switch_off.svg";
import switchWarningIcon from "assets/images/icons/img_device_switch_warning.svg";
import switchDormantIcon from "assets/images/icons/img_device_switch_dormant.svg";
import switchDisabledIcon from "assets/images/icons/img_device_switch_disable.svg";
// Gateway
import gatewayOnlineIcon from "assets/images/icons/img_device_gateway_on.svg";
import gatewayOfflineIcon from "assets/images/icons/img_device_gateway_off.svg";
import gatewayWarningIcon from "assets/images/icons/img_device_gateway_warning.svg";
import gatewayDormantIcon from "assets/images/icons/img_device_gateway_dormant.svg";
import gatewayDisabledIcon from "assets/images/icons/img_device_gateway_disable.svg";
// Router
import routerOnlineIcon from "assets/images/icons/img_device_gateway_on.svg";
import routerOfflineIcon from "assets/images/icons/img_device_gateway_off.svg";
import routerWarningIcon from "assets/images/icons/img_device_gateway_warning.svg";
import routerDormantIcon from "assets/images/icons/img_device_gateway_dormant.svg";
import routerDisabledIcon from "assets/images/icons/img_device_gateway_disable.svg";
// Client
import clientOnlineIcon from "assets/images/icons/img_device_client_on.svg";
import clientOfflineIcon from "assets/images/icons/img_device_client_off.svg";

import { deviceTypeOption, deviceStateOption } from "../const";

import expandIcon from "assets/images/icons/btn_topology_expand.svg";
import collapseIcon from "assets/images/icons/btn_topology_collapse.svg";

const Node = ({
  parentId,
  type,
  state,
  name,
  mac,
  match,
  showName,
  showMac,
  onToggleSlider,
  isCollapsed,
  onToggleCollapse,
  readOnly = false,
}) => {
  let img = null;
  let typeStyle = null;

  if (type === deviceTypeOption.ACCESS_POINT) {
    typeStyle = nodeStyle['ap'];

    switch (state) {
      case deviceStateOption.ONLINE:
        img = <img src={apOnlineIcon} alt='' />;
        break;
      case deviceStateOption.OFFLINE:
        img = <img src={apOfflineIcon} alt='' />;
        break;
      case deviceStateOption.WARNING:
        img = <img src={apWarningIcon} alt='' />;
        break;
      case deviceStateOption.DORMANT:
        img = <img src={apDormantIcon} alt='' />;
        break;
      default:
        break;
    }

    if (!match) {
      img = <img src={apDisabledIcon} alt='' />;
    }
  }

  if (type === deviceTypeOption.SWITCH) {
    typeStyle = nodeStyle['sw'];

    switch (state) {
      case deviceStateOption.ONLINE:
        img = <img src={switchOnlineIcon} alt='' />;
        break;
      case deviceStateOption.OFFLINE:
        img = <img src={switchOfflineIcon} alt='' />;
        break;
      case deviceStateOption.WARNING:
        img = <img src={switchWarningIcon} alt='' />;
        break;
      case deviceStateOption.DORMANT:
        img = <img src={switchDormantIcon} alt='' />;
        break;
      default:
        break;
    }

    if (!match) {
      img = <img src={switchDisabledIcon} alt='' />;
    }
  }

  if (type === deviceTypeOption.GATEWAY) {
    typeStyle = nodeStyle['gw'];

    switch (state) {
      case deviceStateOption.ONLINE:
        img = <img src={gatewayOnlineIcon} alt='' />;
        break;
      case deviceStateOption.OFFLINE:
        img = <img src={gatewayOfflineIcon} alt='' />;
        break;
      case deviceStateOption.WARNING:
        img = <img src={gatewayWarningIcon} alt='' />;
        break;
      case deviceStateOption.DORMANT:
        img = <img src={gatewayDormantIcon} alt='' />;
        break;
      default:
        break;
    }

    if (!match) {
      img = <img src={gatewayDisabledIcon} alt='' />;
    }
  }

  if (type === deviceTypeOption.ROUTER) {
    typeStyle = nodeStyle['router'];

    switch (state) {
      case deviceStateOption.ONLINE:
        img = <img src={routerOnlineIcon} alt='' />;
        break;
      case deviceStateOption.OFFLINE:
        img = <img src={routerOfflineIcon} alt='' />;
        break;
      case deviceStateOption.WARNING:
        img = <img src={routerWarningIcon} alt='' />;
        break;
      case deviceStateOption.DORMANT:
        img = <img src={routerDormantIcon} alt='' />;
        break;
      default:
        break;
    }

    if (!match) {
      img = <img src={routerDisabledIcon} alt='' />;
    }
  }

  if (type === deviceTypeOption.CLIENT) {
    typeStyle = nodeStyle['client'];

    switch (state) {
      case deviceStateOption.ONLINE:
        img = <img src={clientOnlineIcon} alt='' />;
        break;
      case deviceStateOption.OFFLINE:
        img = <img src={clientOfflineIcon} alt='' />;
        break;
      default:
        break;
    }
  }

  let ns = nodeStyle['node'];
  if (!showName && showMac) {
    ns = nodeStyle['no-name-node'];
  }

  if (showName && !showMac) {
    ns = nodeStyle['no-mac-node'];
  }

  if (!showName && !showMac) {
    ns = nodeStyle['no-name-no-mac-node'];
  }

  const handleOpenDrawer = () => {
    if (!onToggleSlider) {
      return;
    }

    const deviceTag = `${type}@${mac}`;
    onToggleSlider(deviceTag);
  }

  return (
    <div
      className={`
        ${ns}
        ${!parentId ? nodeStyle['first-node'] : ''} 
        ${typeStyle}
        ${onToggleCollapse ? nodeStyle['has-expander'] : ''}
      `}
      style={{
        transform: ((showName && !showMac) || (!showName && showMac)) ? 'translateY(10px) !important' : '',
        cursor: readOnly ? 'default' : undefined,
      }}
      onClick={handleOpenDrawer}
    >
      <div className={`${nodeStyle['icon']} ${match ? '' : nodeStyle['not-match-icon']}`}>{img}</div>
      {
        showName && (
          <div className={`${nodeStyle['name']} ${match ? '' : nodeStyle['not-match-name']}`}>{name}</div>
        )
      }
      {
        showMac && (
          <div className={`${nodeStyle['mac']} ${match ? '' : nodeStyle['not-match-mac']}`}>({mac})</div>
        )
      }
      {
        onToggleCollapse && (
          <div
            className={nodeStyle['expander']}
            onClick={(e) => {
              e.stopPropagation();
              onToggleCollapse();
            }}
          >
            <img src={isCollapsed ? expandIcon : collapseIcon} alt="expand" />
          </div>
        )
      }
    </div>
  );
};

export default Node;
